// Investiture
import React from 'react';
import Investiture2025 from '../views/Investiture2025';

const InvestiturePage = () => {
  return <Investiture2025 />;
};

export default InvestiturePage;
